export const STATE_KEY = 'customerDetails'

export const SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS'
export const SET_CUSTOMER_DETAILS_LOADING = 'SET_CUSTOMER_DETAILS_LOADING'
export const SET_CUSTOMER_DETAILS_ERROR = 'SET_CUSTOMER_DETAILS_ERROR'
export const SET_CUSTOMER_DETAILS_NOT_FOUND = 'SET_CUSTOMER_DETAILS_NOT_FOUND'
export const CLEAR_CUSTOMER_DETAILS = 'CLEAR_CUSTOMER_DETAILS'
export const SET_EQUITY_REFRESHING = 'SET_EQUITY_REFRESHING'
export const SET_EQUITY_REFRESH_DONE = 'SET_EQUITY_REFRESH_DONE'

const initialState = {
  loading: false,
  hasLoaded: false,
  error: null,
  notFound: false,
  customerId: null,
  resolvedSessionId: null,
  customer: null,
  vehicles: [],
  previouslyOwnedVehicles: [],
  serviceHistory: [],
  serviceMeta: null,
  warranties: null,
  communications: null,
  lifetimeValue: null,
  ltvComponents: null,
  vehicleDetails: {},
  visitHistory: [],
  visitClickPaths: [],
  financing: null,
  narratives: null,
  wants: [],
  dealShapeLine: null,
  wantsNarrative: null,
  customerSince: null,
  lifetimeActivity: null,
  vehicleDeals: {},
  // vehicle-ids the backend flagged for an on-demand equity refresh (spreads
  // in off the payload); equityRefreshing is true while the one-shot
  // POST /cdp/refresh-equity + re-fetch is in flight (equity widgets spin).
  equityRefreshPending: [],
  equityRefreshing: false,
}

export default function customerDetailsReducers(state = initialState, action) {
  switch (action.type) {
    case SET_CUSTOMER_DETAILS_LOADING:
      return { ...state, loading: true, error: null, notFound: false, customerId: action.payload }

    case SET_CUSTOMER_DETAILS:
      return {
        ...state,
        loading: false,
        hasLoaded: true,
        error: null,
        ...action.payload,
        // renamed off the payload's sessionId so it never collides with the
        // route-param sessionId prop the page already carries
        resolvedSessionId: action.payload.sessionId,
      }

    case SET_CUSTOMER_DETAILS_ERROR:
      return { ...state, loading: false, hasLoaded: true, error: action.payload }

    case SET_CUSTOMER_DETAILS_NOT_FOUND:
      return { ...state, loading: false, hasLoaded: true, notFound: true }

    case SET_EQUITY_REFRESHING:
      return { ...state, equityRefreshing: true }

    case SET_EQUITY_REFRESH_DONE:
      return { ...state, equityRefreshing: false }

    case CLEAR_CUSTOMER_DETAILS:
      return { ...initialState }

    default:
      return state
  }
}
